import React, { Component } from 'react';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import IconButton from '@material-ui/core/IconButton';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import { connect } from 'react-redux';
import { auth, db, firebase } from '../../firebase';
import * as routes from '../../constants/routes';
import KobooRoundInput from '../../constants/KobooRoundInput.css';
import styles from '../../constants/stylesDefault';
import KobooButton from '../Layout/KobooButton';
import { getRoles } from '../../store/roles/actions';
import { ROLE_RENTER } from '../../constants/roles';
import { handleError } from '../../store/infos/actions';

const byPropKey = (propertyName, value) => () => ({
  [propertyName]: value,
});

const INITIAL_STATE = {
  email: '',
  password: '',
  showPassword: false,

};

export class SignInForm extends Component {
  constructor(props) {
    super(props);

    this.state = { ...INITIAL_STATE };
  }

  handleClickShowPassword = () => {
    this.setState({ showPassword: !this.state.showPassword });
  };

  firebaseSignOut = (roles, authUser) => {
    const {
      history,
    } = this.props;

    if (roles[authUser.uid] < ROLE_RENTER) {
      firebase.auth.signOut()
        .then(() => {
          this.props.handleError({ error: { message: 'Access forbidden' } });
        })
        .catch((error) => {
          this.props.handleError(error);
        });
    } else {
      this.setState(() => ({ ...INITIAL_STATE }));
      history.push(routes.DASHBOARD);
    }
  };

  onSubmit = (event) => {
    const {
      email,
      password,
    } = this.state;
    auth.doSignInWithEmailAndPassword(email, password)
      .then((authUser) => {
        db.getRoles()
          .then((snapshot) => {
            const roles = snapshot.val();
            this.firebaseSignOut(roles, authUser);
          });
      })
      .catch((error) => {
        this.props.handleError(error);
      });

    event.preventDefault();
  };

  render() {
    const {
      email,
      password,
    } = this.state;

    const isInvalid =
          password === '' ||
          email === '';

    return (
      <form onSubmit={this.onSubmit} style={styles.center}>

          <TextField
              style={KobooRoundInput.round}
              placeholder="Email"
              id="signin-email"
              type="text"
              onChange={event => this.setState(byPropKey('email', event.target.value))}
              margin="normal"
              value={email}
              InputProps={{
                  disableUnderline: true,
              }}
          />

          <Input
              style={KobooRoundInput.round}
              placeholder="Mot de passe"
              id="signin-password"
              type={this.state.showPassword ? 'text' : 'password'}
              value={password}
              onChange={event => this.setState(byPropKey('password', event.target.value))}
              disableUnderline={true}
              endAdornment={
                  <InputAdornment position="end">
                      <IconButton
                          aria-label="Toggle password visibility"
                          onClick={this.handleClickShowPassword}
                          onMouseDown={this.handleMouseDownPassword}
                      >
                          {this.state.showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                  </InputAdornment>
              }
          />
          <KobooButton disabled={isInvalid} type="submit">
              Connexion
          </KobooButton>
      </form>
      );
    }
}

const mapStateToProps = state => ({
  authUser: state.users.authUser,
  roles: state.roles.content,
  pending: state.roles.pending,
});

export default connect(mapStateToProps, { getRoles, handleError })(SignInForm);



// WEBPACK FOOTER //
// ./src/components/SignInForm/SignInForm.jsx